import React from 'react';
import { Code2, Cpu, Cloud, Smartphone, Workflow, ShieldCheck, GitBranch } from 'lucide-react';
import { ServicePage } from '../components/ServicePage';
export function ProductEngineering() {
  return <ServicePage badgeText="PRODUCT ENGINEERING" badgeIcon={<Code2 className="w-3.5 h-3.5" data-id="element-555" />} titleStart="Build products" titleAccent="that scale" titleAccentColor="blue" subtitle="From MVP to enterprise-grade platforms, our engineers ship reliable, performant software. Modern stack, rigorous quality, on-time delivery." heroIcon={Code2} heroIconColor="text-brand-blue" heroIconBg="bg-blue-50" checklist={['Full-stack web apps', 'iOS & Android apps', 'Cloud-native architecture', 'CI/CD & DevOps']} features={[{
    title: 'Web Applications',
    description: 'React, Next.js, and TypeScript apps built for performance, accessibility, and scale.',
    icon: Code2
  }, {
    title: 'Mobile Apps',
    description: 'Native iOS, Android, and cross-platform apps with delightful UX and 5-star reviews.',
    icon: Smartphone
  }, {
    title: 'Cloud Architecture',
    description: 'AWS, GCP, and Azure setups that are secure, scalable, and cost-efficient.',
    icon: Cloud
  }, {
    title: 'API & Backend',
    description: 'REST and GraphQL APIs, microservices, and event-driven systems.',
    icon: Cpu
  }, {
    title: 'DevOps & CI/CD',
    description: 'Automated pipelines, infrastructure-as-code, and observability built in.',
    icon: GitBranch
  }, {
    title: 'Quality & Security',
    description: 'Automated testing, security audits, and compliance from day one.',
    icon: ShieldCheck
  }]} processSteps={[{
    number: '01',
    title: 'Scope',
    description: 'Technical discovery to define architecture, stack, and milestones.'
  }, {
    number: '02',
    title: 'Sprint',
    description: 'Weekly demos and tight feedback loops keep everyone aligned.'
  }, {
    number: '03',
    title: 'Ship',
    description: 'Production launch with monitoring, alerting, and runbooks in place.'
  }, {
    number: '04',
    title: 'Support',
    description: 'Ongoing maintenance, scaling, and feature development.'
  }]} ctaTitle="Ready to ship your next product?" ctaSubtitle="Tell us what you're building — we'll help you make it real." data-id="element-554" />;
}